module.exports = __webpack_public_path__ + "static/media/navidad4.bb9fafe2.jpg";